var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutFluMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 162,
    viewBox: "0 0 285 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2724 162C105.564 161.782 125.565 154.24 119.395 143.235C113.24 132.257 111.61 118.766 91.2724 118.419C70.9352 118.766 69.3051 132.257 63.15 143.235C56.9796 154.24 76.9809 161.782 91.2724 162Z",
    fill: "#81A1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.702 154.642C113.006 154.424 133.025 146.871 126.849 135.85C120.689 124.857 119.057 111.347 98.702 111C78.3469 111.347 76.7154 124.857 70.5549 135.85C64.3791 146.871 84.398 154.424 98.702 154.642Z",
    stroke: "#4C566A",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.21 128.379V134.669",
    stroke: "#4C566A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1943 128.379V134.669",
    stroke: "#4C566A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.23 125C200.513 124.573 161.722 109.784 173.689 88.2053C185.626 66.6801 188.788 40.2268 228.23 39.5476C267.671 40.2268 270.833 66.6801 282.77 88.2053C294.737 109.784 255.946 124.573 228.23 125Z",
    fill: "#EBCB8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.82 110.573C186.079 110.146 147.255 95.3355 159.232 73.7264C171.18 52.1708 174.344 25.6802 213.82 25C253.297 25.6802 256.461 52.1708 268.409 73.7264C280.386 95.3355 241.561 110.146 213.82 110.573Z",
    stroke: "#4C566A",
    strokeWidth: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.26 59.0773V71.4096",
    stroke: "#4C566A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.381 59.0773V71.4095",
    stroke: "#4C566A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8039 75C60.7252 74.697 88.6059 64.1966 80.0048 48.8758C71.4249 33.5929 69.1527 14.811 40.8039 14.3288C12.455 14.811 10.1828 33.5929 1.60292 48.8758C-6.99822 64.1966 20.8825 74.697 40.8039 75Z",
    fill: "#B48EAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1603 64.7568C71.0992 64.4534 99.0044 53.9382 90.3957 38.5957C81.8083 23.2913 79.5341 4.48292 51.1603 4C22.7866 4.48292 20.5123 23.2913 11.925 38.5957C3.31626 53.9382 31.2214 64.4534 51.1603 64.7568Z",
    stroke: "#4C566A",
    strokeWidth: 8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6255 28.1949V36.9508",
    stroke: "#4C566A",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6951 28.1949V36.9508",
    stroke: "#4C566A",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutFluMobile);
export default __webpack_public_path__ + "static/media/about-flu-mobile.353fba7ae0fa66534bf076fefa38aafd.svg";
export { ForwardRef as ReactComponent };